import React, { useState } from "react";
import { Accordion, AccordionSummary, AccordionDetails, Typography, Box, Divider, Button } from "@mui/material";
import styles from './styles.module.css'
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import CancelSubscription from "./CancelSubscriptionModal";

const BillingAccordian = ({ details, handleChange, expandedPanels, subscriptionStatus }) => {
    const [open, setOpen] = useState(false);
    const handleClose = () => {
        setOpen(false);
    };

    const getPaymentMethod = (paymentData) => {
        let paymentMethodType = paymentData?.payment_method?.type;
        if(paymentData?.payment_method?.type === "card"){
            return `${paymentMethodType} - ${paymentData?.payment_method?.card?.last4}`
        }else{
            return paymentMethodType;
        }
    };
    
    return (
        <Accordion
            expanded={expandedPanels.includes('billing')}
            onChange={handleChange('billing')}
            className={styles.accordion}
        >
            <AccordionSummary expandIcon={<ExpandMoreIcon />} className={!expandedPanels.includes("business") ? styles.accordionSummary : ""}>
                <Typography variant="gothamLarge" className={styles.accordionTitle}>Billing & Subscription</Typography>
            </AccordionSummary>
            <AccordionDetails>
                {details?.payment_info ?
                    <>
                        <Typography variant="gothamMedium" className={styles.subscriptionHeading}>Your Subscription is 
                            <span className={styles.activeClass}>
                                {
                                    subscriptionStatus === "incomplete_expired" || subscriptionStatus === "canceled"
                                    ? ` Inactive`
                                    : details?.payment_info?.plan_details?.active ? ` Active` : ` Inactive`
                                }
                            </span>
                        </Typography>
                        {details?.payment_info?.plan_details?.active &&
                            <Typography variant="gothamMedium" >You are billed {details?.payment_info?.plan_details?.interval === 'year' ? 'annually' : 'monthly'}, your subscription renews on on the {new Date(details?.payment_info?.current_period_end * 1000).toLocaleDateString("en-GB")}.</Typography>
                        }
                        <Typography variant="gothamMedium" className={styles.subscriptionHeading}>Your Payment Method</Typography>
                        <Typography variant="gothamMedium" > {`${getPaymentMethod(details?.payment_info)}`} ·  Expires {`${details?.payment_info?.payment_method?.card?.exp_month}/${details?.payment_info?.payment_method?.card?.exp_year}`}.</Typography>
                        {/* <Button variant="outlined" className={styles.paymentButton}>Edit Payment Method</Button> */}
                        <Typography variant="gothamMedium" className={styles.subscriptionHeading}>Cancel Subscription </Typography>
                        <Typography variant="gothamMedium" >After cancelling, you’ll be able to use Local Physio until the end of your billing period.</Typography>
                        <Button variant="outlined" className={styles.paymentButton} onClick={() => setOpen(true)}>Cancel Subscription</Button>
                        <CancelSubscription details={details} open={open} onClose={handleClose} />

                    </> :
                    <Typography variant="gothamMedium">Subscription Info is not available</Typography>
                }
            </AccordionDetails >
        </Accordion>
    );
};

export default BillingAccordian;
